var I18n, Optimize, config;

window._ = require('underscore');

window.md5 = require('../../../src/frontend/vendor/md5');

window.Cookie = require('../../../src/frontend/vendor/cookie');

window.Hogan = require('hogan.js');

require('../groupon_modules/modernizr-hacks');

I18n = require('../../../node_modules/grapefruit/lib/I18n');

window.I18n = new I18n();

require('optimize-suite');

require('../../../src/frontend/vendor/eventPause-custom');

require('jquery.finger');

window.CartWidget = require('../../../modules/cart_widget/frontend/cart_widget');

window.Fingerprint = require('fingerprintjs');

Optimize = window.Optimize;

config = Optimize.suiteData.config;

config.finch = {
  config: Optimize.finchConfig
};

Optimize.config = config;

OptimizeSuite.init(config);

